import { Button } from 'primereact/button'
import { Dropdown } from 'primereact/dropdown'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import Modal from '../../components/popup/Modal'

const ChuyenDuyetVanBangBanSao = (props) => {
  const { onSubmit, visible, toggle } = props

  const [noiDung, setNoiDung] = useState(null)
  const [isError, setIsError] = useState(false)
  const { users } = useSelector((state) => state.user)

  useEffect(() => {
    setIsError(false)
    setNoiDung('')
  }, [visible])

  const footer = () => (
    <div className="flex justify-content-end w-full pt-2">
      <Button
        label="Huỷ"
        className="p-button-secondary mr-2"
        onClick={() => {
          setNoiDung('')
          if (toggle) toggle()
        }}
      />
      <Button
        onClick={async () => {
          if (!noiDung) {
            setIsError(true)
            return
          }
          if (onSubmit) onSubmit(noiDung)
          toggle()
          setIsError(false)
        }}
        label="Lưu"
      />
    </div>
  )
  return (
    <>
      <Modal header="Chuyển người duyệt" visible={visible} toggle={toggle} footer={footer}>
        <div className="w-full field">
          <Dropdown
            className={`w-full ${isError ? 'p-invalid' : ''}`}
            optionValue="id"
            optionLabel="fullname"
            options={users}
            value={noiDung}
            onChange={(e) => setNoiDung(e.value)}
          />
          {isError && (
            <small className="p-invalid text-red-500">Người duyệt không được để trống</small>
          )}
        </div>
      </Modal>
    </>
  )
}
export default ChuyenDuyetVanBangBanSao
